var map = {
	"./core/Drawer.vue": "41c0",
	"./core/NestedField.vue": "a59f",
	"./core/Toolbar.vue": "d23b",
	"./core/View.vue": "9306",
	"./core/ViewAuth.vue": "4aa2",
	"./core/ViewWidget.vue": "b645",
	"./core/Warnings.vue": "ebab",
	"./helper/AddPhone.vue": "a191",
	"./helper/ConfirmDialog.vue": "f6ff",
	"./helper/Cropper.vue": "02c9",
	"./helper/DepositFunds.vue": "4ff5",
	"./helper/FillProfile.vue": "23bf6",
	"./helper/IconCustom.vue": "2a5b",
	"./helper/Loading.vue": "bc33",
	"./helper/MaintenanceMode.vue": "a75e",
	"./helper/Notification.vue": "e0d3",
	"./helper/Offset.vue": "c6cc",
	"./helper/StartWhiteLabel.vue": "ef0f",
	"./helper/SuccessAnimation.vue": "d1d5",
	"./helper/Suspended.vue": "715d",
	"./helper/VersionDialog.vue": "084f",
	"./icons/IconBotManager.vue": "6b00",
	"./icons/IconBots.vue": "77a4",
	"./icons/IconBtc.vue": "9727",
	"./icons/IconCalc.vue": "c0ca",
	"./icons/IconCompany.vue": "3573",
	"./icons/IconDashboard.vue": "1592",
	"./icons/IconInvoice.vue": "0b40",
	"./icons/IconLabel.vue": "8dc4",
	"./icons/IconLinked.vue": "138f",
	"./icons/IconMyBots.vue": "3a74",
	"./icons/IconPortfolio.vue": "8d26",
	"./icons/IconProduct.vue": "5d66",
	"./icons/IconProject.vue": "71b3",
	"./icons/IconRating.vue": "4420",
	"./icons/IconUser.vue": "2e0e",
	"./icons/IconWallet.vue": "d0fc",
	"./ui/Checkbox.vue": "71da",
	"./ui/Select.vue": "2ab1",
	"./ui/Text.vue": "9dde",
	"./ui/Textarea.vue": "e21e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ffe0";